import * as Yup from "yup";

export const roleSchema = Yup.object().shape({
    name: Yup.string()
        .min(2, "Nome do cargo muito curto")
        .required("O nome do cargo é obrigatório"),
    description: Yup.string().nullable(),
    status: Yup.string().default("active"),
    permissions: Yup.object().default({}),
});
